export default __webpack_public_path__ + "static/media/Gloves of Pandemonium.89ca85cf.jpg";